// Loads all blog posts (migrated from WordPress) at build time via Vite glob.
export type BlogTocItem = { id: string; text: string; level: 2 | 3 };

export type BlogPost = {
  slug: string;
  title: string;
  date: string; // YYYY-MM-DD
  excerpt: string;
  readingTime: number;
  toc: BlogTocItem[];
  html: string;
};

const modules = import.meta.glob<BlogPost>("./blog/*.json", {
  eager: true,
  import: "default",
});

export const BLOG_POSTS: BlogPost[] = Object.values(modules).sort(
  (a, b) => +new Date(b.date) - +new Date(a.date),
);

export const BLOG_POSTS_BY_SLUG: Record<string, BlogPost> = BLOG_POSTS.reduce(
  (acc, p) => {
    acc[p.slug] = p;
    return acc;
  },
  {} as Record<string, BlogPost>,
);

export const getBlogPost = (slug?: string): BlogPost | undefined =>
  slug ? BLOG_POSTS_BY_SLUG[slug] : undefined;

// Returns N related posts (most recent excluding current).
export const getRelatedPosts = (slug: string, n = 3): BlogPost[] =>
  BLOG_POSTS.filter((p) => p.slug !== slug).slice(0, n);
